// Project / reference entries.
//
// Add one object per approved, real project. NEVER invent customers,
// locations, quantities, dates or outcomes — publish only verified projects
// the business has approved for public display.
//
// Fields:
//   slug                 URL slug, e.g. 'elementmaja-tootja-eesti'
//   title / titleEt      Public project title
//   country / countryEt  Country where the project was delivered
//   projectType          'house-manufacturer' | 'dealer' | 'construction' | 'private'
//   customerName         Optional — only if the customer agreed to be named
//   customerPublic       boolean — true only with explicit permission
//   productSlugs         slugs from products.js used in the project
//   quantity             Optional — number of doors
//   dimensions           Optional — non-standard dimensions used
//   colours              Optional — finishes / colours
//   technicalRequirements / technicalRequirementsEt
//                        Array of requirement strings
//   description / descriptionEt
//   images               Array of { src, alt, altEt } — real photos only
//   completionDate       Optional 'YYYY-MM'
//   featured             boolean — highlight on /projects
//   published            boolean — only published:true entries are rendered

export const projects = [];
